export const DO_NOT_TRACK_ATTRIBUTE_NAME = 'data-no-analytics' as const
export const DO_NOT_TRACK_SELECTOR = `[${DO_NOT_TRACK_ATTRIBUTE_NAME}]`
export const DO_NOT_TRACK_ATTRIBUTE_PROPS = { [DO_NOT_TRACK_ATTRIBUTE_NAME]: '' } as const

export const SEARCH_ANALYTICS_ATTRIBUTE_NAME = 'data-search-analytics' as const
export const SEARCH_ANALYTICS_ATTRIBUTE_PROPS = { [SEARCH_ANALYTICS_ATTRIBUTE_NAME]: '' } as const
export const SEARCH_ANALYTICS_FORM_SELECTOR = `[${SEARCH_ANALYTICS_ATTRIBUTE_NAME}]`
export const SEARCH_ANALYTICS_INPUT_NAME = 'search'
